import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import {
  modalBody,
  modalCloseBtn,
  modalDangerBtn,
  modalSecondaryBtn,
  modalShell,
  modalSubtitle,
  modalTitle,
} from "./ui/modalDesign";

export function useConfirm() {
  const [data, setData] = useState({
    message: "",
    title: "Please confirm",
    resolver: null,
  });

  const confirm = (message, title = "Please confirm") => {
    return new Promise((resolve) => {
      setData({
        message,
        title,
        resolver: resolve,
      });
    });
  };

  const close = (answer) => {
    if (data.resolver) data.resolver(answer);
    setData({ message: "", title: "Please confirm", resolver: null });
  };

  const ConfirmDialog = () => {
    if (!data.resolver) return null;

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#1B1530]/45 p-4 backdrop-blur-[3px]">
        <div className={`${modalShell} w-full max-w-md`}>
          <div className={`relative ${modalBody} text-center`}>
            <button
              type="button"
              aria-label="Close"
              className={modalCloseBtn}
              onClick={() => close(false)}
            >
              <X size={18} />
            </button>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-100 text-amber-600">
              <AlertTriangle size={20} />
            </div>
            <h1 className={modalTitle}>{data.title}</h1>
            <p className={modalSubtitle}>{data.message}</p>
            <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row">
              <button type="button" onClick={() => close(false)} className={modalSecondaryBtn}>
                Cancel
              </button>
              <button type="button" onClick={() => close(true)} className={modalDangerBtn}>
                Yes, continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return { confirm, ConfirmDialog };
}
